class ZetaApi {
  #domain = window.location.href.includes('gocart-stg') ? "dev-wego.search.zetacx.net" : "wego.search.zetacx.net";
  #path;
  #paramsObj = {};
  #paramsUtilObj = null;

  constructor() {
    this.#paramsUtilObj = new ParamsUtil();
  }

  async request() {
    const params = this.#paramsUtilObj.makeQueryStrings();

    let url = `https://${this.#domain}/${this.#path}`;
    url += params ? `?${params}` : "";

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
      });

      return await response.json();
    } catch (error) {
      console.error(`error: ${error}`);
    }
  }

  set endPoint(path) {
    this.#path = path;
  }

  getParam(key) {
    return this.#paramsObj[key];
  }

  initializeParams() {
    this.#paramsUtilObj.initializeParams();
    this.#updateParamsObject();
  }

  #updateParamsObject() {
    this.#paramsObj = this.#paramsUtilObj.paramsObj;
  }

  deleteParam(key, value) {
    this.#paramsUtilObj.deleteParam(key, value);
    this.#updateParamsObject();
  }

  deleteParams(key) {
    this.#paramsUtilObj.deleteParams(key);
    this.#updateParamsObject();
  }

  deleteInsertParam(key, value) {
    this.#paramsUtilObj.deleteInsertParam(key, value);
    this.#updateParamsObject();
  }

  upsertParam(key, value) {
    this.#paramsUtilObj.upsertParam(key, value);
    this.#updateParamsObject();
  }

  decodeValue(value) {
    return decodeURIComponent(value);
  }
}
